<template>
	<dl :class="listClass">
		<dt :class="titleClass" class="heavy" v-html="title"/>
		<dd class="sr-only" v-html="maxSeverity"/>
		<dd>
			<button
				:class="alertClass()" class="icon"
				@click.prevent="showAlertModal()">Show Full Health Status
			</button>
		</dd>
	</dl>
</template>
<script>
export default {
	computed: {
		listClass() {
			return {
				"flex items-center gap-0-5": !this.hideTitle,
			};
		},
		titleClass() {
			return {
				"sr-only": this.hideTitle,
			};
		},
		severities() {
			return Object.keys(this.alerts).sort();
		},
		maxSeverity() {
			return _.last(this.severities).split("_")[1];
		},
	},
	methods: {
		alertClass(alert = null) {
			let classes = {};
			let severity = alert?.severity || this.maxSeverity;
			classes["icon--alert--" + severity] = true;
			return classes;
		},
		showAlertModal() {
			this.$vmodal.open({
				component: require("./modals/AlertModal.vue").default,
				props: {
					alerts: this.alerts,
				},
			});
		},
	},
	props: {
		alerts: {
			required: true,
			type: Object,
		},
		title: {
			required: false,
			type: String,
			default() {
				return "Health Status";
			},
		},
		hideTitle: {
			required: false,
			type: Boolean,
			default() {
				return false;
			},
		},
	},
};
</script>
